// extracted by mini-css-extract-plugin
export default {"title":"SideDrawer_title__8CwKE"};